import React from "react";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import FieldLabel from "./FieldLabel";

const SubscriptionNameField = ({ value, onChange, placeholder }) => {
	const { t } = useTranslation();
	return (
		<div>
			<FieldLabel required>{t("label.name")}</FieldLabel>
			<TextField
				name="subscriptionName"
				variant="outlined"
				fullWidth
				value={value || ""}
				placeholder={placeholder || t("placeholder.subscriptionNameExample")}
				onChange={(e) => onChange(e.target.value)}
			/>
		</div>
	);
};

export default SubscriptionNameField;
